import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import {LOG_IN_SUCCESS, LOG_IN_WITH_PASSWORD, LOG_OUT, SET_LOGIN_ACCOUNT} from "./authTypes";
import { post } from "../../api";
import { LOGIN_OPERATOR_URL } from "../../api/apiRoutes";

interface LoginParams {
  email: string;
  password: string;
}

export const logInWithPassword = createAction<{ email: string; password: string }>(LOG_IN_WITH_PASSWORD);
export const login = createAsyncThunk(
  LOG_IN_SUCCESS,
  async (data: LoginParams) => await post(LOGIN_OPERATOR_URL, { name: data.email, password: data.password })
);
export const logOut = createAction<void>(LOG_OUT);
export const setLoginAccount = createAction<any>(SET_LOGIN_ACCOUNT);
